export default __webpack_public_path__ + "static/media/send.eb3b57e2.svg";